module.exports = __webpack_public_path__ + "static/media/apple-logo.97dc9c03.png";